import axios from "axios";
import qs from "qs";
import { Toast } from "antd-mobile";
import { checkLoginRequest } from "@action/checkLogin";
import { SUCCESS_CODES, NOT_LOGIN_CODES } from "@utils/config";
import { BFD_checkApp, BFD_LoginOut } from "@utils/bfdApp";
import { getQueryString, getCookie } from "@utils/index";
// import { getCatchAddress } from '@utils/locationApi/location';
import { getCatchAddress } from 'dflocationsdk';
import API_ENV from "./API_ENV";
import { sha1 } from "./SHA";

let gateWayUrl; // 网关
let apiUrl; // 接口
let bfdAPI; // 百福得接口

if (/test\d{2}$/g.test(API_ENV)) {
  if (API_ENV == 'test05') {
    gateWayUrl = "/gw/app";
    apiUrl = "/mallapi";
    bfdAPI = "/mall/bff";
  } else {
    gateWayUrl = `http://appzuul.${API_ENV}.com`;
    apiUrl = `http://api.${API_ENV}.com`;
  }
} else {
  switch (API_ENV) {
    case "test":
      const domain = window?.df_sdk_common?.grayDomain(`https://corp.m.dongfangfuli`)
      gateWayUrl = `${domain}/gw/app`;
      apiUrl = `${domain}/mallapi`;
      bfdAPI = `${domain}/mall/bff`;
      break;
    case "development":
      // gateWayUrl = "http://appzuul.test01.com";
      // apiUrl = "http://api.test01.com";
      // gateWayUrl = "https://m.dongfangfuli.com//gw/app";
      // apiUrl = "https://m.dongfangfuli.com/mallapi";
      // gateWayUrl = "http://corp.m.test05.dongfangfuli.com/gw/app";
      // apiUrl = "http://corp.m.test05.dongfangfuli.com/mallapi";
      // gateWayUrl = "http://www-test05.dongfangfuli.com/gw/app";
      // apiUrl = "http://www-test05.dongfangfuli.com/mallapi";
      gateWayUrl = "/gw/app";
      apiUrl = "/mallapi";
      bfdAPI = "/mall/bff";
      break;
    default:
      gateWayUrl = "/gw/app";
      apiUrl = "/mallapi";
      bfdAPI = "/mall/bff";
      break;
  }
}

const VISITOR_CODE = [1000000, 1000001, 'AUTH001003', 'AUTH001004']
// 游客或者体验码code
function isVisitorCode(code) {
  return VISITOR_CODE.some(item => String(item) === String(code))
}
// 获取返回结果的错误信息
function getResMsg(res) {
  return res.msg || res.message
}
// 接口错误时是否toast提示（仅对原方法的抽取）
function showErrorToast(res) {
  const resMsg = getResMsg(res);
  if (resMsg && !SUCCESS_CODES.includes(res.code) && !isVisitorCode(res.code)) {
    Toast.info(resMsg, 3);
  }
}

/**
 * 创建一个axios实例
 */
const _axios = axios.create();
// 请求前添加拦截器
const _axiosReq = _axios.interceptors.request.use(
  config => {
    const isUnion = window.location.host.split(".")[0] === "corp" || getQueryString('union');
    const add = getCatchAddress()
    const localAddress = add ? JSON.parse(add) : {};
    const city = localAddress?.cityId || (localStorage.getItem("city")
      ? localStorage.getItem("city").split(",")[0]
      : getQueryString('city') ? getQueryString('city')
        : "145");
    const defaultParams = {
      platform: 1,
      city,
      cityId: city,
      unionFlag: isUnion ? 1 : 0
    };
    if (isUnion) {
      defaultParams.union = isUnion ? getCookie("UNION") ? getCookie("UNION") : String(getQueryString('union')) : null
    }

    if (config.url.indexOf('unityShop/queryMallGrayScale') > -1) {
      const _params = getParamsEncryption(Object.assign({}, defaultParams, config.data));
      _params.union = isUnion ? getCookie("UNION") ? getCookie("UNION") : String(getQueryString('union')) : null
      config.data = _params
      return config;
    }
    config.data = Object.assign({}, defaultParams, config.data);
    return config;
  },
  error => Promise.reject(error)
);

// 响应后添加拦截器
const _axiosRes = _axios.interceptors.response.use(response => {
  let { data } = response;
  if (data.respCode) {
    data.code = Number(data.respCode);
    data.msg = data.respMsg;
  }

  if (isVisitorCode(data.code)) {

    window.dfShowGuestModal && window.dfShowGuestModal((type) => {
      // 对应处理逻辑
      if (type == 'cancel') {

      } else if (type == 'login') {

      }
    }, window.loginUrl, data.code);
    return data
  }

  if (parseInt(response.status) === 200) {
    return response.data;
  }
  return Promise.reject({
    code: response.data.code,
    msg: response.data.msg || response.data.message
  });
});

/**
 * 封装获取数据的请求方法
 * @param  { String }  url    接口路径
 * @param  { Object }  params 请求的参数
 * @param  { Boolean } immediate 区别mallAPI和appAPI接口
 * @param  { Boolean } bffFlag 区别bff接口
 * @return { Promise }
 */
export function sendPost(url, params, immediate, bffFlag, baseURL) {
  const getBaseURL = () => {
    if (baseURL) return baseURL;
    if (bffFlag) return bfdAPI;
    return immediate ? apiUrl : gateWayUrl;
  }

  return _axios({
    url,
    method: "post",
    data: params,
    baseURL: getBaseURL(),
    transformRequest: [
      function _(data) {
        return (immediate || bffFlag)
          ? qs.stringify(data, { allowDots: true })
          : JSON.stringify(data);
      }
    ],
    headers: {
      'terminal': window.navigator.userAgent.indexOf('MAX-APP') > -1 ? 'maxapp' : '',
      "Content-Type": (immediate || bffFlag)
        ? "application/x-www-form-urlencoded"
        : "application/json",
      // "Business-Type": 1
      ...window?.__df_channel_sdk?.getRequestHeader()
    },
    timeout: 6000,
    withCredentials: true
  })
    .then(res => {
      if (NOT_LOGIN_CODES.includes(res.code)) {
        if (window.__wxjs_environment === 'miniprogram') {
          // 如果是小程序,跳转小程序登录页
          wx.miniProgram.navigateTo({
            url: `/pages/login/login?returnUrl=${encodeURIComponent(
              window.location.href,
            )}`,
          });
          return;
        }
        const isBFDAPP = BFD_checkApp();
        if (isBFDAPP) {
          BFD_LoginOut();
          return;
        }

        // const city = localStorage.getItem('city') ? localStorage.getItem('city').split(',')[0] : '145'
        const union = getCookie("UNION") || "";
        // const UNION_URL = union ? `/union/${union}` : ``;
        let return_url = window.location.href;
        if (window.location.href.indexOf("union") === -1 && union) {
          return_url =
            return_url.indexOf("?") > -1
              ? `${return_url}&union=${union}`
              : `${return_url}?union=${union}`;
        }
        // let data = {
        //   union: '0',
        //   unionFlag: '0'
        // };
        // if (union) {
        //   data = {
        //     union: union,
        //     unionFlag: 1
        //   };
        // }
        // const href = API_ENV === 'dev'
        //   ? `//corp.m.test01.com/union/sszz/user/login?city=${city}&returnUrl=${encodeURIComponent(return_url)}`
        //   : `${resp.loginUrl}/user/login?city=${city}&returnUrl=${encodeURIComponent(return_url)}`;
        Toast.info(res.msg, 0.8, () => {
          checkLoginRequest().then(resp => {
            if (!resp.loginFlag && resp.loginUrl) {
              if (
                window.__wxjs_environment === "miniprogram"
              ) {
                // 跳转小程序
                return window.wx.miniProgram.redirectTo({ url: "/pages/login/login" });
              }
              const href = `${resp.loginUrl}&returnUrl=${encodeURIComponent(
                return_url
              )}`;
              window.df_sdk_common.location.href = href;
            }
          });
        });
        return res;
      }

      showErrorToast(res);

      return res;
    })
    .catch(err => {
      switch (err.request.status) {
        case 500:
          Toast.info("接口请求 500", 0.8);
          return Promise.reject({
            code: 500,
            msg: "接口请求 500 "
          });
        case 502:
          Toast.info("接口请求 502", 0.8);
          return Promise.reject({
            code: 500,
            msg: "接口请求 502 "
          });
        case 101001:
          Toast.info("系统错误", 0.8);
          return Promise.reject({
            code: 101001,
            msg: "系统错误"
          });
        case 404:
          Toast.info("接口 404", 0.8);
          return Promise.reject({
            code: 101001,
            msg: "接口 404"
          });
        default:
          Toast.info(err.msg || "网络错误", 0.8);
      }
    });
}

export function sendPostByDfGw(url, params) {
  return sendPost(url, params, false, false, '/df-gw');
}

/**
* 请求加密
* @param {*} params 参数
* @param {*} appid 应用ID
* @param {*} secretKey 加密编码
*/
export function getParamsEncryption(params, appid, secretKey = 'XCwAjoB4') {
  const apiParams = {
    appId: '100060',
    msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
    timestamp: +new Date(),
    version: '1.0.1',
    body: JSON.stringify(params),
    sign: '',
  }
  apiParams.sign = sha1(secretKey + apiParams.body + secretKey)
  return apiParams
}
export { _axios, _axiosReq, _axiosRes };
